export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOADS = '/loads';
export const ROUTE_PARTIES = '/parties';
export const ROUTE_PARTIES_ADD = '/parties/add';
export const ROUTE_MEASURE = '/measure';
export const ROUTE_PARTIES_EDIT = '/parties/edit';
export const ROUTE_REPORTS = '/reports';
export const ROUTE_PARTIES_GRAIN = '/parties-grain';
export const ROUTE_PARTIES_GRAIN_ADD = '/parties-grain/add-grain';
export const ROUTE_PARTIES_GRAIN_EDIT = '/parties-grain/edit-grain';
export const ROUTE_REPORTS_GRAIN = '/reports-grain';
export const ROUTE_MEASURE_GRAIN = '/measure-grain';
